import * as React from 'react';

import * as styles from './styles.css';
import { BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { IPageState } from '../../types/page';
import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';
import { useApplicationContext } from '../../utils/applicationContext';
import { Card } from '../Card';
import { Preloader } from '../Preloader';
import { experimentToggle } from '../experimentToggle';
import { ResultsEmptyForAuthorizationContainer } from '../../containers/ResultsEmptyForAuthorizationContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';

interface IResultsMobile {
  results: IResultsState;
  page: IPageState;
  isFavoritesForAuthorizationEnabled: boolean;
  removeFavorite(entityId: number): void;
}

export const ResultsMobile: React.FC<IResultsMobile> = ({
  results,
  page,
  isFavoritesForAuthorizationEnabled,
  removeFavorite,
}) => {
  const { status, favoriteEntities, total } = results;
  const { config } = useApplicationContext();

  /**
   * @todo Удалить переменную когда будет удален фича-тогл redesignFavorites.Enabled
   */
  const isSavedSearchFavoritesMergeExperimentActive = config.get<boolean>('redesignFavorites.Enabled') || false;

  const renderFavorites = () => {
    if (favoriteEntities.length === 0) {
      return <ResultsEmptyContainer />;
    }

    if (isFavoritesForAuthorizationEnabled) {
      return <ResultsEmptyForAuthorizationContainer />;
    }

    return (
      <>
        {favoriteEntities.map((favoriteEntity, index) => (
          <Card
            key={'item-' + favoriteEntity.entityId}
            total={total}
            favoriteEntity={favoriteEntity}
            page={page}
            position={index + 1}
            removeFavorite={removeFavorite}
          />
        ))}
        {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
          <div key="preloader" className={styles['preloader']}>
            <Preloader size={64} />
          </div>
        )}
      </>
    );
  };

  /**
   * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
   */
  return experimentToggle(
    isSavedSearchFavoritesMergeExperimentActive,
    BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
    <div className={styles['container--redesign']}>{renderFavorites()}</div>,
    <div className={styles['container']}>{renderFavorites()}</div>,
  );
};
